module.exports = __webpack_public_path__ + "static/media/add.59aca6cb.svg";